/*=====================================
    GameTransactionView

    Author: Ac
    CreateTime: 2018 / 10 / 03
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import { Route } from 'react-router-dom';
import BreadCrumbs from 'components/commons/BreadCrumbs';
import GameSaleView from 'components/game/GameSaleView';
import GamePurchaseView from 'components/game/GamePurchaseView';
import GameProducts from 'components/game/GameProducts';
import GLOBAL from 'nonnglobal';
import CupoyImage from 'components/commons/CupoyImage';

/*--------------------------
    Styled
--------------------------*/
const Container = styled.div`
    flex: 1;
`;
const Header = GlobalStyle.BasicBlock.extend`
    margin-top: ${GlobalStyle.ViewSpace}px;
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;
const Title = styled.div`
    font-size: 16px;
    font-weight: bold;
    margin: 0px 19px 0px 20px;
`
const NavList = styled.ul`
    display: grid;
    grid-template-columns: ${props => `repeat(${props.gridNum}, auto) 1fr`};
    grid-auto-flow: column;
    justify-content: start;
    align-items: center;
    margin: 0;
`;
const NavItemTouch = styled.div`
    height: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 9px;
    color: inherit;
`;
const NavItem = styled.li`
    margin-left: 30px;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 1px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
    > div {
    border-bottom: 2px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
    }

    ${NavItemTouch} {
        color: ${props => props.isActive ? Colors.MAIN_COLOR : '#4A4A4A'};
        font-weight: ${props => props.bold && props.isActive ? 'bold':''}
    }

    &:first-child {
    margin-left: ${props => props.marginLeft? props.marginLeft:30}px;
    }
`;
const EmptySpace = styled.div`
    padding-bottom: 10px;
`;
const ADCoverLink = styled.a`
  min-width: ${GlobalStyle.SidebarWidth}px;
  width: ${GlobalStyle.SidebarWidth}px;
  margin-left: ${GlobalStyle.ViewSpace}px;
  padding-top: 30px;
  border-radius: 3px;
  overflow: hidden;
  align-self: flex-start;
`;
const ADCover = styled.div`
  width: ${GlobalStyle.SidebarWidth}px;
  height: 600px;
  background-color: ${Colors.ImgBackground};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

/**
 * Components
 */
const ADSidebar = ({ game }) => {

    if (!game) {
        return null;
    }

    const {
        gameid,
        uprightadvimg,
        uprightadvlinkurl = 'about:blank',
    } = game;
    
    if (!uprightadvimg) {
        return null;
    }
    
    const imgSrc = `${GLOBAL.imgSrcRootURL}/gameimgs/${gameid}/${uprightadvimg}`;
    
    return (
        <ADCoverLink
          href={uprightadvlinkurl}
          rel='noopener noreferrer'
          target='_blank'
        >
          <CupoyImage
            stylecomponent={ADCover}
            src={imgSrc}
          />
        </ADCoverLink>
    );
};

ADSidebar.propTypes = {
    game: PropTypes.object,
};

/*--------------------------
    Main Component
--------------------------*/
class GameTransactionView extends Component {

    // static propTypes = {
    // };

    constructor(props) {
        super(props);

        this.getGameStoreCache = this.getGameStoreCache.bind(this);

        const routerState = CupoyRouter.getCurrent();
        const { params } = routerState;
        const { gameid, serverid } = params;

        this.state = {
            gameid,
            serverid,
        };
    }

    componentDidMount() {

        const {
            gameid, 
            serverid,
        } = this.state;

        window.scrollTo({
            top: 0,
        });

        const game = this.getGameStoreCache();

        if(!game || !game.updatetime){
            this.props.gameActions.getGameDetail({
                gameid,
            });
        }

        if(!serverid){

            const gameSeverListById = this.props.gameSeverListById;
            const { cupoyStateReplace } = this.props.webActions;

            if(!gameSeverListById || !gameSeverListById[gameid] || Object.keys(gameSeverListById[gameid]).length === 0){

                this.props.gameActions.getGameServerList({
                    gameid: gameid,
                }).then(() => {

                    const { gameSeverListById } = this.props;

                    if(!gameSeverListById[gameid]) {
                        return;
                    }
                    const gameSeverById = gameSeverListById[gameid][0] || {};
                    const serverid = gameSeverById.gameserverid;

                    cupoyStateReplace(CupoyRouter.STATES.GAME_TRANSACTION_SALE, {
                        gameid: gameid,
                        serverid: serverid,
                    });
                });
            } else {
                cupoyStateReplace(CupoyRouter.STATES.GAME_TRANSACTION_SALE, {
                    gameid: gameid,
                    serverid: serverid || gameSeverListById[gameid][0].gameserverid,
                });
            }   
            return;         
        }
    }

    getGameStoreCache() {
        
        const {
            gameListMap,
        } = this.props;

        const {
            gameid,
        } = this.state;

        const game = gameListMap[gameid];

        return game;
    }

    render() {

        const {
            gameid,
        } = this.state;

        const game = this.getGameStoreCache();

        if(!game){
            return null;
        }

        const {
            gamename = '',
            isshowpurchase,
            // updatetime,
            webeventlinkurl: webEventLinkUrl,
        } = game;

        const path = {
            preState: 'game',
            preTitle: '遊戲列表',
            title: gamename.trim(),
        };

        // Banner 還不確定需不需要 by:Ac
        // console.log(`${GLOBAL.imgSrcRootURL}/gameimgs/${gameid}/tn_${gameid}_thumb.png?t=${updatetime}`);

        return (
            <React.Fragment>
                <Container>
                    <BreadCrumbs path={path} />

                    {isshowpurchase
                        ? (
                            <React.Fragment>
                                {this.renderHeader()}
                                <Route path={CupoyRouter.PATHS.GAME_TRANSACTION_SALE} component={GameSaleView} exact />
                                <Route path={CupoyRouter.PATHS.GAME_TRANSACTION_PURCHASE} component={GamePurchaseView} exact />
                            </React.Fragment>
                        ) : <EmptySpace />
                    }

                    <GameProducts
                        gameid={gameid}
                        webEventLinkUrl={webEventLinkUrl}
                    />
                </Container>

                <ADSidebar game={game} />
            </React.Fragment>
        );
    }

    renderHeader = () => {

        const { gameid, serverid } = this.state;

        return (
            <Header>
                <NavList gridNum={3} >
                    <Title>虛寶市集</Title>
                    <CupoySrefView
                        statename={CupoyRouter.STATES.GAME_TRANSACTION_SALE}
                        params={{ gameid, serverid }}
                    >
                        <NavItem bold isActive={CupoyRouter.isActive(CupoyRouter.STATES.GAME_TRANSACTION_SALE)}>
                            <NavItemTouch>出售區</NavItemTouch>
                        </NavItem>
                    </CupoySrefView>
                    <CupoySrefView
                        statename={CupoyRouter.STATES.GAME_TRANSACTION_PURCHASE}
                        params={{ gameid, serverid }}
                    >
                        <NavItem bold isActive={CupoyRouter.isActive(CupoyRouter.STATES.GAME_TRANSACTION_PURCHASE)}>
                            <NavItemTouch>收購區</NavItemTouch>
                        </NavItem>
                    </CupoySrefView>
                </NavList>
            </Header>
        );
    }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        sellerMap: state.vitem.sellerMap,
        isloading: state.vitem.isloading,
        gameSeverListById: state.game.gameSeverListById,
        gameListMap: state.game.gameListMap,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(GameTransactionView);